/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Ref_H1Inputs */

const en_sorter_ref_h1 = /** @type {(inputs: Sorter_Ref_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keys`)
};

const ko_sorter_ref_h1 = /** @type {(inputs: Sorter_Ref_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`키`)
};

const ja_sorter_ref_h1 = /** @type {(inputs: Sorter_Ref_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キー`)
};

/**
* | output |
* | --- |
* | "Keys" |
*
* @param {Sorter_Ref_H1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_ref_h1 = /** @type {((inputs?: Sorter_Ref_H1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Ref_H1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_ref_h1(inputs)
	if (locale === "ko") return ko_sorter_ref_h1(inputs)
	return ja_sorter_ref_h1(inputs)
});